import { ChannelListFilterKey } from '../../../../interfaces/IChannelListFilter';

export type ChannelListFilterDraftValueOption = { value: string; label: string; color?: string };
export type ChannelListFilterDraftValue = ChannelListFilterDraftValueOption[] | boolean;
export type ChannelListFilterDraft = Record<ChannelListFilterKey, ChannelListFilterDraftValue>;

export const defaultChannelListFilterDraft: ChannelListFilterDraft = {
  channelStatusIds: [],
  assigneeIds: [],
  tagNames: [],
  appointmentClinicEmployeeIds: [],
  appointmentTypeIds: [],
  appointmentRoomIds: [],
  unread: [],
  showArchived: false,
};
